import { Helmet } from "react-helmet-async";

const SITE = "https://bandofotovoltaico24.it";
const DEFAULT_IMAGE = "https://images.pexels.com/photos/159397/solar-panel-array-power-sun-electricity-159397.jpeg?auto=compress&cs=tinysrgb&w=1200";

/**
 * SEO helper: sets title, meta description, canonical, OG and Twitter Card
 * for a public page. Pass `noindex` to hide the page from search engines
 * (used for /admin, /admin/login, /privacy, /cookie, /404).
 *
 * Does NOT touch layout, styles or visible copy — head-only.
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
  type = "website",
  status = null, // e.g. "404" for prerender-status-code
}) {
  const url = SITE + path;
  const robots = noindex ? "noindex,follow" : "index,follow";
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Bandofotovoltaico24" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {status && <meta name="prerender-status-code" content={status} />}
    </Helmet>
  );
}
